export default __webpack_public_path__ + "static/media/informe-convoca.0492bc90.png";